<template>
  <box-view class="revenue-report-view" title="Báo cáo doanh thu" :showBack="true" @close="$router.push('/admin')">
    <div class="container-fluid py-3">
      
      <!-- Filter -->
      <revenue-filter 
        :filter="reportFilter" 
        :users="users" 
        :categories="categories"
        @update="updateFilter"
      />

      <!-- KPIs -->
      <revenue-summary-cards :summary="reportSummary" />

      <!-- Charts -->
      <revenue-chart 
        :report-daily-revenue="reportDailyRevenue"
        :report-by-category="reportByCategory"
      />

      <!-- Tabbed Data Tables -->
      <revenue-table 
        :report-by-product="reportByProduct"
        :report-by-category="reportByCategory"
        :report-by-user="reportByUser"
      />

    </div>
  </box-view>
</template>

<script>
import RevenueFilter from '@/components/reports/RevenueFilter.vue'
import RevenueSummaryCards from '@/components/reports/RevenueSummaryCards.vue'
import RevenueTable from '@/components/reports/RevenueTable.vue'
import RevenueChart from '@/components/reports/RevenueChart.vue'

export default {
  name: 'RevenueReport',
  components: {
    RevenueFilter,
    RevenueSummaryCards,
    RevenueTable,
    RevenueChart
  },
  props: {
    reportSummary: Object,
    reportByProduct: Array,
    reportByCategory: Array,
    reportByUser: Array,
    reportDailyRevenue: Array,
    reportFilter: Object,
    users: Array,
    categories: Array
  },
  methods: {
    updateFilter(newFilter) {
      this.$emit('update-report-filter', newFilter);
    }
  }
};
</script>

